import {
    AfterViewInit,
    ChangeDetectionStrategy,
    Component,
    ElementRef,
    EventEmitter,
    Output,
    ViewChild
} from '@angular/core';
import { Store } from '@ngrx/store';
import { TypeaheadMatch } from 'ngx-bootstrap/typeahead';
import { fromEvent, Observable } from 'rxjs/index';
import { debounceTime, distinctUntilChanged, filter, map, tap } from 'rxjs/operators';
import { Person } from '../../core/model/central/person.model';
import { PatientsActions } from './state/patients.actions';
import { PatientsSelectors } from './state/patients.selectors';

@Component({
    selector: 'patient-search',
    templateUrl: './patients-search.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class PatientsSearchComponent implements AfterViewInit {
    @Output() readonly patientSelect: EventEmitter<number> = new EventEmitter<number>();

    @ViewChild('patientSearchInput') patientSearchInput: ElementRef;
    foundPatients$: Observable<Array<Person>>;
    selectedPatient: Person = {personId: undefined, remotePersonId: undefined, personName: ''};
    searchByPet = false;

    constructor(private store: Store<any>,
                private patientsSelectors: PatientsSelectors
    ) {
        this.foundPatients$ = this.patientsSelectors.selectSearchPatients()
            .pipe(
                filter(patients => patients !== undefined)
            );
    }

    ngAfterViewInit(): void {
        this.patientSearchInput.nativeElement.focus();
        this.subscribeToKeyDownEvents();
    }

    subscribeToKeyDownEvents(): void {
        // typeaheadWaitMs does NOT debounce input but delays when found list pops up
        // So we have to roll our own
        fromEvent(this.patientSearchInput.nativeElement, 'keyup')
            .pipe(
                map(($event: any) => $event.target.value),
                filter((searchPattern: string) => searchPattern.length > 2),
                debounceTime(500),
                distinctUntilChanged())
            .subscribe((searchPattern: string) => {
                if (!this.searchByPet) {
                    this.store.dispatch(PatientsActions.searchPatient({searchPattern}));
                } else {
                    this.store.dispatch(PatientsActions.searchPatientByPetName({searchPattern}));
                }
            });

        // NOTE: no need to unsubscribe to fromEvent as this only adds a reference in the DOM
    }

    onSelect($event: TypeaheadMatch): void {
        this.selectedPatient = $event.item;
        this.patientSelect.emit(this.selectedPatient.personId);
    }

    searchBy(): void {
        this.searchByPet = !this.searchByPet;
    }
}
